import { type FC, useContext } from "react";

import { FORMAT_TEXT_COMMAND } from "lexical";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import { faUnderline } from "@fortawesome/free-solid-svg-icons/faUnderline";

import { EditorToolbarContext } from "./editor_toolbar_context";
import { IconButton } from "./icon_button";

export const EditorToolbarButtonUnderline: FC = () => {
  const [editor] = useLexicalComposerContext();
  const { isUnderline } = useContext(EditorToolbarContext);

  return (
    <IconButton
      icon={faUnderline}
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline");
      }}
      aria-label="Underline"
      selected={isUnderline}
    />
  );
};
